// CW Payment Hub (Java app-services) endpoint resolution.
//
// The payment gateway was migrated from the cw-auth Next.js API routes
// (/api/paymentGateway/...) to CW App Services (/api/paymenthub/v1/...).
// REACT_APP_PAYMENT_HUB_URL points at the app-services base, e.g.
//   https://services.ofc-qa.cwcloud.in/app-services/
// It is a tenant-aware URL key: env.paymentHubUrl reads window.__CW_TENANT_URLS__
// (CW Browser injects it per tenant at runtime) before falling back to the
// build-time .env value. When it is not configured anywhere, we fall back to
// the legacy cw-auth gateway so environments can be cut over one at a time.
import env from "../config/env";

const hubBase = () => {
  const base = env.paymentHubUrl;
  if (!base) return null;
  return base.endsWith("/") ? base : `${base}/`;
};

// Generic EDC router (Pine Labs / Razorpay EDC / Paytm EDC): ?apiType=...
export const paymentGatewayUrl = () => {
  const base = hubBase();
  return base ? `${base}api/paymenthub/v1/gateway` : `${process.env.REACT_APP_API_URL}api/paymentGateway`;
};

// Razorpay dynamic QR: {base}/create-qr, {base}/poll-qr
export const razorpayQrBaseUrl = () => {
  const base = hubBase();
  return base ? `${base}api/paymenthub/v1/razorpay-qr` : `${process.env.REACT_APP_API_URL}api/paymentGateway/razorPay`;
};

// CCAvenue hosted page: {base}/initiate, {base}/poll-status
export const ccavenueBaseUrl = () => {
  const base = hubBase();
  return base ? `${base}api/paymenthub/v1/ccavenue` : `${process.env.REACT_APP_API_URL}api/paymentGateway/ccavenue`;
};
